import {
    PAYMENT_ORDERS_LOAD_FAILURE,
    PAYMENT_ORDERS_LOAD_REQUEST,
    PAYMENT_ORDERS_LOAD_SUCCESS,
    PaymentOrdersLoadFailureAction,
    PaymentOrdersLoadRequestAction,
    PaymentOrdersLoadSuccessAction,
} from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.actions';
import { initialPaymentOrdersState } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.constants';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { LoadingState, loadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface PaymentOrdersState {
    outputFilename: string;
    outputXML: string;
    loadingState: LoadingState;
    errorMessage: string;
}

declare type PaymentOrdersReducerAction =
    PaymentOrdersLoadRequestAction
    | PaymentOrdersLoadSuccessAction
    | PaymentOrdersLoadFailureAction;

const paymentOrdersReducer: Reducer<PaymentOrdersState> = (state = initialPaymentOrdersState, action: PaymentOrdersReducerAction) => {
    switch (action.type) {
        case PAYMENT_ORDERS_LOAD_REQUEST:
        case PAYMENT_ORDERS_LOAD_FAILURE: {
            return tupdate(state, {
                outputFilename: null,
                outputXML: null,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        case PAYMENT_ORDERS_LOAD_SUCCESS: {
            return tupdate(state, {
                outputFilename: action.response.result.outputFilename,
                outputXML: action.response.result.outputXML,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        default:
            return state;
    }
};

export default paymentOrdersReducer;
